import { useCspUrls } from "./useCspUrls";
import { useEffect } from "react";

const CSPContainer = () => {
  const { data: cspHeaders } = useCspUrls();

  useEffect(() => {
    if (cspHeaders) {
      const meta = document.createElement("meta");
      meta.httpEquiv = "Content-Security-Policy";
      const metaUrls = cspHeaders?.whiteListedUrls?.reduce(
        (acc: string, url: string) => {
          return (acc += " " + url);
        },
        ""
      );
      meta.content = `upgrade-insecure-requests; child-src data: cdkdrive: microsoft-edge: msteams: blob: mailto: tel: com.cdk.servicebookpro: com.cdk.inspectpro: http://localhost:3000/* ${metaUrls}`;
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
  }, [cspHeaders]);

  return null;
};

export default CSPContainer;